export default __webpack_public_path__ + "static/media/logomark.94dd3d36.png";